import { render } from "./Mpesa_Offline_Uploads.vue?vue&type=template&id=3571888a"
import script from "./Mpesa_Offline_Uploads.vue?vue&type=script&lang=js"
export * from "./Mpesa_Offline_Uploads.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__